import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            justifyContent: 'center',
        },
        content: {},
        table: {
            flexGrow: 1,
            minWidth: '60%',
        },
        outButton: {
            backgroundColor: 'white',
            color: grey[400],
        },
        nextButton: {
            paddingTop: theme.spacing(2),
            alignSelf: 'flex-end',
            marginRight: '20%',
        },
        formControllers: {
            display: 'flex',
            minWidth: '61%',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignContent: 'flex-end',
            marginBottom: theme.spacing(1),
        },
        chipButton: {
            backgroundColor: 'transparent',
            border: 'none',
        },
        chip: {
            color: grey[50],
        },
    })
);